import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import styled from "styled-components";
import { getSlug } from "./util";
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";

const PhotoViewerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  padding: 0 1rem;

  img {
    margin: 0;
    padding: 0;
    height: 200px;
    margin: 0 1rem 1rem 1rem;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    object-fit: cover;
    object-position: center;
  }

  @media (max-width: 800px) {
    img {
      width: 90%;
      height: 40vh;
    }
  }
`;

interface IProps {
  tag: string;
}

const PhotoViewer = ({ tag }: IProps) => {
  const data = useStaticQuery(
    graphql`
      query CloudinaryImage {
        allCloudinaryMedia(sort: { fields: created_at, order: DESC }) {
          edges {
            node {
              secure_url
              tags
              resource_type
              height
              width
              created_at
            }
          }
        }
      }
    `
  );
  const images = data.allCloudinaryMedia.edges;

  const filteredImages = images.filter((image: any) => {
    return image.node.tags.includes(tag);
  });

  const uiElements: any = [
    // add custom UI element
    {
      name: "custom-button",
      ariaLabel: "Custom button",
      order: 9,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner:
          '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 122.88 114.318" enable-background="new 0 0 122.88 114.318" xml:space="preserve"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M122.88,35.289L87.945,70.578v-17.58c-22.091-4.577-39.542,0.468-52.796,17.271 c2.301-34.558,25.907-51.235,52.795-52.339L87.945,0L122.88,35.289L122.88,35.289z"/><path d="M6.908,23.746h35.626c-4.587,3.96-8.71,8.563-12.264,13.815H13.815v62.943h80.603V85.831l13.814-13.579v35.159 c0,3.814-3.093,6.907-6.907,6.907H6.908c-3.815,0-6.908-3.093-6.908-6.907V30.653C0,26.838,3.093,23.746,6.908,23.746L6.908,23.746 z"/></g></svg>',
        outlineID: "pswp__icn-cstm-btn",
      },
      appendTo: "bar",
      onInit: (el, pswpInstance) => {
        // do something on UI element's init event
      },
      onClick: (e, el, pswpInstance) => {
        // do something on UI element's click event

        if (navigator.share) {
          navigator
            .share({
              title: "Forgotten Coast Cakes",
              text: "Check out this cake!",
              url: pswpInstance._initialItemData["data-link"],
            })
            .then(() => console.log("Successful share"))
            .catch((error) => window.location.reload());
        } else location.href = pswpInstance._initialItemData["data-link"];
      },
    },

    // add another custom UI element
    // ...
  ];

  return (
    <>
      <PhotoViewerContainer className="container">
        <Gallery withCaption uiElements={uiElements}>
          {filteredImages.map((image: any, index: number) => (
            <Item
              original={image.node.secure_url}
              height={image.node.height}
              width={image.node.width}
              data-link={getSlug(image.node)}
              caption={
                image.node.tags.filter(
                  (tag: any) =>
                    tag !== "cake" &&
                    tag !== "cupcakes" &&
                    tag !== "wedding" &&
                    tag !== "fave"
                )[0] || ""
              }
              key={index}
            >
              {({ ref, open }: { ref: any; open: any }) => (
                <img
                  ref={ref}
                  onClick={open}
                  src={image.node.secure_url}
                  alt={""}
                ></img>
              )}
            </Item>
          ))}
        </Gallery>
      </PhotoViewerContainer>

      {filteredImages.map((image: any, index: number) => (
        <a href={getSlug(image.node)} key={index} style={{ display: "none" }}>
          {image.node.tags.filter(
            (tag: any) =>
              tag !== "cake" &&
              tag !== "cupcakes" &&
              tag !== "wedding" &&
              tag !== "fave"
          )[0] || ""}
        </a>
      ))}
    </>
  );
};

export default PhotoViewer;
